// removed by extract-text-webpack-plugin
module.exports = {"AppContainer":"_2kZYXtbG60qgxcz7TQn5qs","appContainer":"_2kZYXtbG60qgxcz7TQn5qs"};


//////////////////
// WEBPACK FOOTER
// ./src/App.css
// module id = 204
// module chunks = 0